<p-panel [hisDdKey]="ddKey" [showHeader]="" [header]="header ? ( header | hisUi ): null">

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<div class="infoMessage" *ngIf="infoMessage">
		<span [innerHTML]="infoMessage | hisUi"></span>
	</div>

	<div [class]="hisBaseGlobalsService.getDd(ddKey).required ? 'requireMessage' : 'infoMessage'" *ngIf="hisBaseGlobalsService.getDd(ddKey) && noAssignedMessage && (!internalOrganizations?.length) && ( !externalOrganizations?.length)">
		<span [innerHTML]="noAssignedMessage | hisUi"></span>
	</div>
	
	<button *ngIf="assignLink && showAssignButton()" (click)="setIsAddOrganization(true)" hisImage="plus_circ_green" class="transparent" [disabled]="readonly">
		<span>{{ assignLink | hisUi }}</span>
	</button>

	<!-- internal organizations -->
	<div *ngIf="internalOrganizations">
		<res-internal-organization-edit *ngIf="editMode"
			[organizations]="internalOrganizations"
            [readonly]="readonly"
			[isAddOrganization]="isAddOrganization"
			[ddKey]="externalOrganizations? ddKey + '.internal' : ddKey"
			[hisDdContexts]="hisDdDirectiveRegistryService.getManagedContexts()"
			[clearAfterSelection]="clearAfterSelection"
			[singleSelect]="singleSelect"
			(selectedInternalOrgUnitChange)="selectedInternalOrgUnitChange($event)"
			(deleteInternalOrgUnitChange)="deleteInternalOrgUnitChange($event)"
			[tableTemplate]="tableTemplate">
		</res-internal-organization-edit>

		<res-internal-organization-view *ngIf="!editMode"
			[organizations]="internalOrganizations">
		</res-internal-organization-view>
	</div>

	<!-- external organizations -->
	<div *ngIf="externalOrganizations">
		<res-external-organization-edit *ngIf="editMode"
			[organizations]="externalOrganizations"
			[isAddOrganization]="isAddOrganization"
			[readonly]="readonly"
			[newResearchPartner]="newResearchPartner"
            [ddKey]="internalOrganizations? ddKey + '.external' : ddKey"
            [hisDdContexts]="hisDdDirectiveRegistryService.getManagedContexts()"
			[clearAfterSelection]="clearAfterSelection"
			[singleSelect]="singleSelect"
			[showCreateLink]="showCreateLink"
			(selectedExternalOrgUnitChange)="selectedExternalOrgUnitChange($event)"
			(deleteExternalOrgUnitChange)="deleteExternalOrgUnitChange($event)"
			(createExternalOrgUnitChange)="createExternalOrgUnit()">
		</res-external-organization-edit>
        
        <!-- create new external organisation in popup -->
        <res-external-organization-create-dialog *ngIf="editMode && showCreateExternalOrganizationDialog" [(visibility)]="showCreateExternalOrganizationDialog"
            (saveDialogChange)="onFinishCreateExternalOrganizationDialog($event)">
        </res-external-organization-create-dialog>

		<res-external-organization-view *ngIf="!editMode"
			[organizations]="externalOrganizations">
		</res-external-organization-view>
	</div>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

</p-panel>

